import { Input } from '@/components/ui'

const MAX_CHARS = 80

export function CharLimitedInput(props) {
    const { value, onChange, placeholder = '', maxChars = MAX_CHARS, className } = props
    return (
        <div className="position-relative w-100">
            <Input
                type="text"
                className={`${className} tw:pr-12`}
                maxLength={maxChars}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
            />
            <span className="position-absolute top-50 end-0 translate-middle-y pe-2 text-secondary small">
                {value.length}/{maxChars}
            </span>
        </div>
    )
}
